import { Equal, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IValidatedAddresses } from '@llws/lift-entity-interfaces';
import { ActionContext } from 'vuex';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IApiResponse, IFilterPayloadV2, IMetaResponse } from '@/shared';

// Base store configuration
const adminGatewayResourcePath: string = '/property-api/validated-addresses';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IValidatedAddresses>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'validated-addresses/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
    getByProperyId(
      ctx: ActionContext<any, any>,
      payload: {propertyId: string,
        clientId: number},
    ): Promise<IApiResponse<IValidatedAddresses | IValidatedAddresses[], IMetaResponse>> {
      const query: IFilterPayloadV2 = {
        filters: {
          alias: 'va',
          relations: [
            {
              path: 'buildingsHasValidatedAddresses',
              alias: 'bhva',
            },
            {
              path: 'bhva.building',
              alias: 'b',
            },
          ],
          where: [
            Equal('bhva.buildingId', payload.propertyId),
            Equal('b.clientId', payload.clientId),
          ],
        },
      };
      return base.actions.get(ctx, query);
    },
  },
};
